import React, { forwardRef } from 'react';
import { View } from '../../../../../../components/Common/react-native-components';
import MultiSeriesLineChart from '../../../MultiSeriesLineChart';
import Table from '../../../../../../components/Common/Table';
import {
  buildMonthSeriesForMultiLineChart,
  convertCstDataIntoTableCompatibleData,
  currentDateFormat,
  DATE_FORMAT_MAPPING,
  seprateDateAndNonDateColumns
} from '../../../../../../utils/transformChartsAndTableData';
import moment from 'moment';
import { CHART_COLORS } from '../../../../constants';
import GenericNoData from '../../../../../../components/Common/NoData/GenricNoData';
import { cloneDeep, get } from 'lodash';
import MultiFeatureCard from '../../../../../../components/Common/Card/MultiOptionsCard/MultiFeatureCard';
import LowerSampleSizeFooter from '../../../../../../components/Common/LowerSampleSizeFooter';
import { underscoreToText } from '../../../../utils';

const ScoreOverTime = forwardRef((props, ref) => {
  const { item, timeperiodLabel, actionMenuData = [] } = props;
  const itemData = item;
  const lowSampleSize = get(item, 'lowSampleSize');

  if (!get(itemData, 'cstData')) {
    return <GenericNoData />;
  }

  let itemClone = cloneDeep(get(itemData, 'cstData.metric_data[0]'));
  itemClone.splice(itemClone.length - 1, 1);
  const metric_count = [[...itemClone], [...itemClone]];
 const firstRowColumnName = "#"
  const tableData = convertCstDataIntoTableCompatibleData({ ...get(itemData, 'cstData'), metric_count } || {});
  const { columns = [], metric_data = [], rows = [] } = get(itemData, 'cstData') || {};
  const notAllowedColumns = ['number_of_responses'];

  let multiLineChartData = buildMonthSeriesForMultiLineChart(columns, rows, metric_data, CHART_COLORS);

  let finalData = multiLineChartData?.map((e, index) => {
    const rowData = get(tableData, ['table_rows', index]);
    return {
      ...e,
      label: {
        value: get(rowData, 'Total'),
        label: 'Total Pecentage'
      },
      subLabel: {
        value: get(rowData, 'Benchmark'),
        label: 'Same Period Ago'
      }
    };
  })?.filter(e => !notAllowedColumns.includes(e.name));

  const chartCategories = seprateDateAndNonDateColumns(columns)?.dateFields?.map(e => {
    let dateFormat = currentDateFormat(e);
    return moment(e, dateFormat).format(DATE_FORMAT_MAPPING[dateFormat]);
  });

  const renderContent = (activeSwitch, contentRef) => {
    switch (activeSwitch) {
      case 'BAR':
        return (
          <MultiSeriesLineChart
            ref={contentRef}
            widgetData={itemData}
            categories={chartCategories}
            chartType={'line'}
            data={finalData || []}
          />
        );
      case 'TIME':
        return (
          <MultiSeriesLineChart
            ref={contentRef}
            widgetData={itemData}
            categories={chartCategories}
            chartType={'column'}
            data={finalData || []}
          />
        );
      case 'TABLE':
        const customRowFormatter = ({ value, row }) => {
          if (get(itemData, "nonDecimalRows", []).includes(row[firstRowColumnName])) {
            return underscoreToText(value)
          }
        }
        return (
          <View style={{ height: 'auto' }}>
            <Table lowSampleSize={lowSampleSize} table_data={tableData} expendable={false} customRowFormatter={customRowFormatter} />
          </View>
        );
      default:
        return null;
    }
  };

  return (
    <MultiFeatureCard
      title={item?.title}
      subTitle={`Time Period: ${timeperiodLabel}`}
      actionMenu={actionMenuData}
      style={{ childContainer: { paddingVertical: 20 } }}
      enableActionBtn={get(item, 'enableActionBtn', false)}
      enableSwitchTab={get(item, 'enableSwitchTab', false)}
      switchOptions={get(item, 'switchOptions', [])}
      renderContent={renderContent}
      renderFooter={() => <LowerSampleSizeFooter size={get(item, 'lowSampleSize')} />}
    />
  );
});

export default ScoreOverTime;